module.exports = __webpack_public_path__ + "media/base/people-e7f1e623.svg";